module.exports = __webpack_public_path__ + "img/success.c0ac37f7.png";